import { request as openRequest } from './reducers/open';
import { request as getRequest } from './reducers/get';
import { request as updateDataRequest } from './reducers/update';
import { request as createRequest } from './reducers/create';
import { request as searchRequest } from './reducers/search';

import { push as pushRecent } from './reducers/push-recent';
import { subscribe } from './reducers/subscribe';

// eslint-disable-next-line import/no-default-export
export default {
    EVENTS_OPEN_REQUEST: openRequest,
    EVENTS_UPDATE_REQUEST: updateDataRequest,
    EVENTS_CREATE_REQUEST: createRequest,
    EVENTS_PUSH_RECENT: pushRecent,
    EVENTS_SEARCH_REQUEST: searchRequest,
    EVENT_REQUEST: getRequest,
    EVENTS_SUBSCRIBE: subscribe,
};
